import { Button, Badge, ChoiceRadio, ChoiceRadioItem } from '@design-system';

import { ChevronLeft, Sparkles } from 'lucide-react';

import { FREEMIUM_INTENT_OPTIONS } from '@shared';

import type { FreemiumIntentId } from '@shared';

export const INTENT_PRESENTATION: Record<FreemiumIntentId, string> = {
  'rate-action': 'Weigh the options on a premium increase and what to do next.',
  'self-funding': 'See whether paying out of pocket can cover future care.',
  'analyze-policy': 'Review an existing policy’s coverage, gaps, and value.',
  'explore-quotes': 'Compare coverage and pricing across carriers.',
  'ccrc-offer': 'Assess a continuing care community contract and costs.',
  'comprehensive-plan': 'Build a complete long-term care funding strategy.',
  'something-else': 'Tell us what you have in mind and we’ll guide you.',
};

interface IntentSelectorProps {
  clientFirstName: string;
  value: FreemiumIntentId | null;
  onChange: (intent: FreemiumIntentId) => void;
  onContinue: () => void;
  onBack: () => void;
}

export function IntentSelector({
  clientFirstName,
  value,
  onChange,
  onContinue,
  onBack,
}: IntentSelectorProps) {
  return (
    <div className="mx-auto w-full max-w-xl">
      <div className="flex flex-col items-center gap-4 text-center">
        <Badge>
          <Sparkles />
          Let&apos;s tailor the next step
        </Badge>
        <h1 className="text-balance text-3xl font-bold text-gray-950">
          What are you trying to do next for {clientFirstName}?
        </h1>
      </div>

      <ChoiceRadio
        className="mt-6"
        value={value ?? undefined}
        onValueChange={next => onChange(next as FreemiumIntentId)}
      >
        {FREEMIUM_INTENT_OPTIONS.map(option => (
          <ChoiceRadioItem
            key={option.id}
            value={option.id}
            title={option.label}
            description={INTENT_PRESENTATION[option.id]}
          />
        ))}
      </ChoiceRadio>

      <Button
        className="mt-6 w-full"
        size="lg"
        disabled={!value}
        onClick={onContinue}
      >
        Continue
      </Button>

      <div className="mt-4 text-center">
        <Button
          size="lg"
          variant="outline"
          onClick={onBack}
          className="w-full"
        >
          <ChevronLeft />
          Back to care phases summary
        </Button>
      </div>
    </div>
  );
}
